import React from 'react';
import './TianlanSecureLinkLoading.css';

export default function TianlanSecureLinkLoading() {
  return (
    <section className="tl-secure-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="tl-secure-loading-mark">
        <img src="https://cms-static.cdn.91app.com/images/original/11/20907f91-ac0f-46b4-82b1-0aebda39ccbc-1632897043-6ggal54opq_d.png" alt="天藍小舖" />
      </div>
      <h1>正在載入您的訂單</h1>
      <p>為您整理需要填寫的資料，請稍候</p>
      <div className="tl-secure-loading-track" aria-hidden="true"><span /></div>
    </section>
  );
}
